import { PresentationCoverSlideConfigBodyTextAlignment } from '@/types/schema';

interface SlideTextHorizontalPosition {
  left: string;
  right: string;
  /** Set only when the admin gives the text block an explicit width. */
  width?: string;
}

function offsetFrom(value: string, offset: number): string {
  const operator = offset < 0 ? '-' : '+';
  return `calc(${value} ${operator} ${Math.abs(offset)}px)`;
}

/**
 * Position the slide text block from the edge that anchors its body text.
 * Right-aligned text must move its right edge with the drag origin. Moving
 * only the left edge changes its width without moving the visible text.
 *
 * When `textWidth` (slide-coordinate pixels) is set, the block has that
 * fixed width and only its anchored edge is positioned. Otherwise the
 * block stretches to the opposite horizontal padding.
 */
export function getSlideTextHorizontalPosition(
  horizontalPadding: string,
  textOriginX: number,
  bodyTextAlignment?: PresentationCoverSlideConfigBodyTextAlignment | null,
  textWidth?: number | null
): SlideTextHorizontalPosition {
  const isRightAligned =
    bodyTextAlignment ===
    PresentationCoverSlideConfigBodyTextAlignment.RightAligned;
  const left = offsetFrom(horizontalPadding, textOriginX);
  const right = offsetFrom(horizontalPadding, -textOriginX);

  if (textWidth != null) {
    const width = `${textWidth}px`;
    return isRightAligned
      ? { left: 'auto', right, width }
      : { left, right: 'auto', width };
  }

  return {
    left,
    right: isRightAligned ? right : horizontalPadding,
  };
}
